export const buyingFields = ['purchasedate', 'price'];
export const sellingFields = ['solddate', 'sell'];
export const buyingText = 'Enter Purchase Information';
export const sellingText = 'Enter Sale Information';
